import { gql } from 'graphql-request'

export const CREATE_STICKER = gql`
  mutation CreateSticker($createStickerInput: CreateStickerInput!) {
    createSticker(createStickerInput: $createStickerInput) {
      id
    }
  }
`
